import { Injectable } from "@angular/core";
import { forkJoin, of } from "rxjs";
import { map } from "rxjs/operators";
import { AttributeService } from "../../models/attribute.service";

@Injectable()
export class FilterParamsService {
  private DEFAULTS: any = {
    order: "last_notice",
    resolved: "false",
  };

  private ATTR_ID_REGEXP = new RegExp(/^-?[0-9]+$/);
  private ENVIRONMENT_KEY = "context.environment";
  private MODIFY_ATTR_KEYS = [
    "context.route",
    "context.httpMethod",
    this.ENVIRONMENT_KEY,
  ];

  constructor(private attributeService: AttributeService) {}

  // Remove empty filters and modify standard attr filter values from non
  // attrId to attrId (e.g. `filters: { "context.route": "/api/v4/route" }`
  // becomes `filters: { "context.route": "-1232442424" }`).
  public fromState(params: any) {
    const newFilters = { ...this.DEFAULTS };
    const projectId = params.projectId;
    const attrObservables = [] as any;
    const attrObservableIndices = {} as any;

    for (const key of Object.keys(params.filters || {})) {
      const val = params.filters[key];

      // Remove empty filters.
      if (!this.isPresent(key, val)) {
        continue;
      }

      // Is filter one of MODIFY_ATTR_KEYS and has non attrId value?
      if (this.shouldModifyFilter(key, val)) {
        // Fetch attrId for that filter from /attributes API.
        const length = attrObservables.push(
          this.attributeService.query({
            projectId,
            attribute: key,
            value: val,
          }),
        );
        attrObservableIndices[key] = length - 1;
      } else {
        // Filter ok.
        newFilters[key] = val;
      }
    }

    // No observables to resolve? Return new filters.
    if (attrObservables.length === 0) {
      return of(newFilters);
    }

    // Resolve observables for fetching attrId and replace filter non attrId
    // value with attrId value.
    return forkJoin(attrObservables).pipe(
      map((attrsData: any) => {
        for (const key of Object.keys(attrObservableIndices)) {
          const attrs = attrsData[attrObservableIndices[key]].attributes;

          if (attrs && attrs.length > 0) {
            newFilters[key] = attrs[0].id;
          } else {
            delete newFilters[key];
          }
        }

        return newFilters;
      }),
    );
  }

  private isPresent(k: any, v: any) {
    return (
      v != null &&
      v !== 0 &&
      // Allow empty environment filter.
      (v.length !== 0 || k === this.ENVIRONMENT_KEY)
    );
  }

  private shouldModifyFilter(key: string, val: string) {
    return (
      this.MODIFY_ATTR_KEYS.indexOf(key) > -1 && !this.ATTR_ID_REGEXP.test(val)
    );
  }
}
